import { HttpEndpoint } from './http-endpoint';

export class ApiConfig extends HttpEndpoint {
  constructor(json: Partial<ApiConfig> = {}) {
    super(json, { baseUrl: '', path: 'api' });
  }
}
